import { jsx } from "react/jsx-runtime";
import { ApexSubmit } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockApexSubmit = ({
  attrs
}) => /* @__PURE__ */ jsx(ApexSubmit, { ...attrs, children: attrs.content });
BlockApexSubmit.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockApexSubmit as default
};
